/* eslint-disable */
import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import advertisementDetailsLabel from "../labels/advertisement_details_en.json";
import "../../styles/advertisementTable.css";
import Select from "react-select";

const QuestionDetails = ({ additionalAnswers, handleQuestions, additionalAnswersState, applicationFee, applicationFeeWithoutConcession}) => {
    let { applicableAdditionalQuestionsList } = useSelector(state => state.advertisement, shallowEqual);
    let count = 0;
    const isOptedOutConcessionFeeFlag = additionalAnswers && additionalAnswers.length > 0 && additionalAnswers.some(item => item.id === "QueConcessionFeeOptOut" && item.answer === "true");
    return (
        // <div className="advertisement_details_Eligibility border border-light">
        <div >
            {/* <label className="fw-bold">
                {advertisementDetailsLabel.QUESTIONS}
            </label>
            <hr /> */}
            <div className="">
                <table className="table d-table mb-3">
                    <thead>
                        <tr>
                            <th
                                scope="col"
                                className="text-center w10 theadBgColor blue_box"
                            >
                                {advertisementDetailsLabel.No}
                            </th>
                            <th scope="col" className="w70 theadBgColor blue_box">
                                {advertisementDetailsLabel.QUESTION_DESCRIPTION}
                            </th>
                            <th scope="col" className="w20 theadBgColor blue_box">
                                {advertisementDetailsLabel.ANSWER}
                            </th>
                        </tr>
                    </thead>
                    <tbody className="f12">
                        {applicableAdditionalQuestionsList &&
                            applicableAdditionalQuestionsList.map(
                                (que) => {
                                    let isParentAnsValid = false;

                                    if (que.parentId) {
                                        let getParentAnswerValid = applicableAdditionalQuestionsList.find(item => item.id === que.parentId);
                                        let answerValue = additionalAnswers.length > 0 && additionalAnswers.find(item => item.id === getParentAnswerValid.id) && additionalAnswers.find((ans) => ans.id == getParentAnswerValid.id).answer;
                                        // console.log('getParentAnswerValid',getParentAnswerValid)
                                        {/* console.log('que',que)
                                        console.log('answerValue:', answerValue, getParentAnswerValid); */}

                                        if (getParentAnswerValid && getParentAnswerValid.id && answerValue) {
                                            // if(getParentAnswerValid && getParentAnswerValid.id ){
                                            if (que.parentValidation.comparison == "Equals") {
                                                isParentAnsValid = answerValue == que.parentValidation.value || (answerValue).toString() == (que.parentValidation.value).toString()
                                            }
                                            if (que.parentValidation.comparison == "NotEquals") {
                                                isParentAnsValid = answerValue != que.parentValidation.value && (answerValue).toString() != (que.parentValidation.value).toString()
                                            }
                                            if (que.parentValidation.comparison == "In") {
                                                const valuesToCheck = Array.isArray(que.parentValidation.values) ? que.parentValidation.values : [que.parentValidation.values];
                                                isParentAnsValid = valuesToCheck && valuesToCheck.some(val => answerValue.includes(val));
                                            }
                                            if (que.parentValidation.comparison == "NotIn") {
                                                const valuesToCheck = Array.isArray(answerValue) ? answerValue : [answerValue];
                                                isParentAnsValid = valuesToCheck && !valuesToCheck.some(val => que.parentValidation.values.includes(val));
                                            }
                                            if (que.parentValidation.comparison == "Contains") {
                                                isParentAnsValid = String(answerValue).includes(String(que.parentValidation.value));
                                            }
                                            if (que.parentValidation.comparison == "Between") {
                                                isParentAnsValid = parseInt(answerValue) >= parseInt(que.parentValidation.minValue) && parseInt(answerValue) <= parseInt(que.parentValidation.maxValue)
                                            }
                                            if (que.parentValidation.comparison == "GreaterThan") {
                                                isParentAnsValid = parseInt(answerValue) > parseInt(que.parentValidation.minValue)
                                            }
                                            if (que.parentValidation.comparison == "LessThan") {
                                                isParentAnsValid = parseInt(answerValue) < parseInt(que.parentValidation.minValue)
                                            }
                                            if (que.parentValidation.comparison == "GreaterThanEqualTo") {
                                                isParentAnsValid = parseInt(answerValue) >= parseInt(que.parentValidation.minValue)
                                            }
                                            if (que.parentValidation.comparison == "LessThanEqualTo") {
                                                isParentAnsValid = parseInt(answerValue) <= parseInt(que.parentValidation.minValue)
                                            }
                                            if (isParentAnsValid) {

                                                return <tr key={que.id}>
                                                    <td className="w-10 word-break text-center">{++count}</td>
                                                    <td className="word-break">
                                                        {que.question}
                                                        <span className="redColor">{que.validation ? '*' : ''}</span>
                                                    </td>
                                                    <td className="word-break">
                                                        {que.answerType.includes("Text") ||
                                                            que.answerType.includes("Date") ||
                                                            que.answerType.includes("Number") ? (
                                                            <input
                                                                type={que.answerType}
                                                                className="form-control"
                                                                name={que.id}
                                                                id={que.id}
                                                                value={additionalAnswers.find((ans) => ans.id === que.id)?.answer ?? ''}
                                                                required={que.validation}
                                                                onChange={handleQuestions}
                                                            />
                                                        ) :

                                                            // (
                                                            //     <div>
                                                            //         <label>
                                                            //             <input
                                                            //                 type="radio"
                                                            //                 className="radio"
                                                            //                 name={que.id}
                                                            //                 id={que.id}
                                                            //                 value={true}
                                                            //                 onChange={handleQuestions}
                                                            //             />
                                                            //             &nbsp;{advertisementDetailsLabel.YES}
                                                            //             &nbsp;&nbsp;
                                                            //         </label>
                                                            //         <label>
                                                            //             <input
                                                            //                 type="radio"
                                                            //                 className="radio"
                                                            //                 name={que.id}
                                                            //                 id={que.id}
                                                            //                 value={false}
                                                            //                 onChange={handleQuestions}
                                                            //             />
                                                            //             &nbsp;{advertisementDetailsLabel.NO}
                                                            //         </label>
                                                            //     </div>
                                                            // )

                                                            (
                                                                (que.answerType.includes("MultiValue")) ? (
                                                                    <Select
                                                                        id={que.id}
                                                                        name={que.id}
                                                                        isMulti={true}
                                                                        getOptionValue={(option) => option.value}
                                                                        getOptionLabel={(option) => option.label}
                                                                        value={additionalAnswers.find((ans) => ans.id === que.id)?.answer?.map(ans => ({ label: ans, value: ans })) ?? []}
                                                                        onChange={(e) => {
                                                                            let createdObj = { "target": { "name": que.id, "value": e.map(option => option.value) } };

                                                                            handleQuestions(createdObj);
                                                                        }}
                                                                        options={(que.validation && que.validation.values && que.validation.values.length > 0)
                                                                            ? que.validation.values.map(option => ({ label: option, value: option }))
                                                                            : []}
                                                                    />

                                                                ) : (
                                                                    (que.answerType.includes("Choice")) ? (
                                                                        <select
                                                                            className="form-control"
                                                                            id={que.id}
                                                                            name={que.id}
                                                                            value={additionalAnswers.find((ans) => ans.id === que.id)?.answer ?? ''}
                                                                            onChange={handleQuestions}
                                                                        >
                                                                            <option value="">{advertisementDetailsLabel.SELECT}</option>
                                                                            {que.validation && que.validation.values && que.validation.values.length > 0 && que.validation.values.map((val) => {
                                                                                return <option value={val}>{val}</option>
                                                                            })}
                                                                        </select>
                                                                    ) : (
                                                                        <div>
                                                                            <label>
                                                                                <input
                                                                                    type="radio"
                                                                                    className="radio"
                                                                                    name={que.id}
                                                                                    id={que.id}
                                                                                    value={true}
                                                                                    onChange={handleQuestions}
                                                                                />
                                                                                &nbsp;{advertisementDetailsLabel.YES}
                                                                                &nbsp;&nbsp;
                                                                            </label>
                                                                            <label>
                                                                                <input
                                                                                    type="radio"
                                                                                    className="radio"
                                                                                    name={que.id}
                                                                                    id={que.id}
                                                                                    value={false}
                                                                                    onChange={handleQuestions}
                                                                                />
                                                                                &nbsp;{advertisementDetailsLabel.NO}
                                                                            </label>
                                                                        </div>
                                                                    )
                                                                )
                                                            )
                                                        }
                                                    </td>
                                                </tr>
                                            } else {

                                                let getParentAnswerValid = applicableAdditionalQuestionsList.find(item => item.id === que.parentId);
                                                let answerValue = additionalAnswers.length > 0 && additionalAnswers.find(item => item.id === getParentAnswerValid.id) && additionalAnswers.find((ans) => ans.id == getParentAnswerValid.id).answer;

                                                let additionalAnswersList = [...additionalAnswers]
                                                let getRemovedList = additionalAnswersList.length > 0 && additionalAnswersList.filter(item => item.id !== que.id);
                                                if (JSON.stringify(getRemovedList) !== JSON.stringify(additionalAnswersList)) {

                                                    additionalAnswersState([...getRemovedList]);
                                                }

                                            }
                                        }

                                    }
                                    else {


                                        return <tr key={que.id}>
                                            <td className="w-10 word-break text-center">{++count}</td>
                                            <td className="word-break">
                                                {que.question}
                                                <span className="redColor">{que.validation ? '*' : ''}</span>
                                                {((que.id === "QueConcessionFeeOptOut") && (isOptedOutConcessionFeeFlag)) &&
                                                    <>
                                                        <br/>
                                                        <label className="text-danger">{advertisementDetailsLabel.CONCESSION_FEES}: {applicationFee}</label> &nbsp;&nbsp;&nbsp;&nbsp;
                                                        <label className="text-danger">{advertisementDetailsLabel.WITHOUT_CONCESSION_FEES}: {applicationFeeWithoutConcession}</label>
                                                    </>
                                                }
                                            </td>
                                            <td className="word-break">
                                                {que.answerType.includes("Text") ||
                                                    que.answerType.includes("Date") ||
                                                    que.answerType.includes("Number") ? (
                                                    <input
                                                        type={que.answerType}
                                                        className="form-control"
                                                        name={que.id}
                                                        id={que.id}
                                                        value={additionalAnswers.find((ans) => ans.id === que.id)?.answer ?? ''}
                                                        onChange={handleQuestions}
                                                        required={que.validation}
                                                    />
                                                ) : (
                                                    (que.answerType.includes("MultiValue")) ? (

                                                        <Select
                                                            id={que.id}
                                                            name={que.id}
                                                            isMulti={true}
                                                            getOptionValue={(option) => option.value}
                                                            getOptionLabel={(option) => option.label}
                                                            value={additionalAnswers.find((ans) => ans.id === que.id)?.answer?.map(ans => ({ label: ans, value: ans })) ?? []} // Map the selected answers to objects
                                                            onChange={(e) => {

                                                                let createdObj = { "target": { "name": que.id, "value": e.map(option => option.value) } }; // Only pass values to handleQuestions

                                                                handleQuestions(createdObj);
                                                            }}
                                                            options={(que.validation && que.validation.values && que.validation.values.length > 0)
                                                                ? que.validation.values.map(option => ({ label: option, value: option })) // Convert string to object for options
                                                                : []}
                                                        />

                                                    ) : (
                                                        (que.answerType.includes("Choice")) ? (
                                                            <select
                                                                className="form-control"
                                                                id={que.id}
                                                                name={que.id}
                                                                value={additionalAnswers.find((ans) => ans.id === que.id)?.answer ?? ''}
                                                                onChange={handleQuestions}
                                                            >
                                                                <option value="">{advertisementDetailsLabel.SELECT}</option>
                                                                {que.validation && que.validation.values && que.validation.values.length > 0 && que.validation.values.map((val) => {
                                                                    return <option value={val}>{val}</option>
                                                                })}
                                                            </select>
                                                        ) : (
                                                            <div>
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        className="radio"
                                                                        name={que.id}
                                                                        id={que.id}
                                                                        value={true}
                                                                        onChange={handleQuestions}
                                                                    />
                                                                    &nbsp;{advertisementDetailsLabel.YES}
                                                                    &nbsp;&nbsp;
                                                                </label>
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        className="radio"
                                                                        name={que.id}
                                                                        id={que.id}
                                                                        value={false}
                                                                        onChange={handleQuestions}
                                                                    />
                                                                    &nbsp;{advertisementDetailsLabel.NO}
                                                                </label>
                                                            </div>
                                                        )
                                                    )
                                                )}
                                            </td>
                                        </tr>
                                    }

                                }
                                // (que) => (
                                //     <tr key={que.id}>
                                //         <td className="w-10 word-break text-center">{++count}</td>
                                //         <td className="word-break">
                                //             {que.question}
                                //             <span className="redColor">*</span>
                                //         </td>
                                //         <td className="word-break">
                                //             {que.answerType.includes("Text") ||
                                //                 que.answerType.includes("Date") ||
                                //                 que.answerType.includes("Number") ? (
                                //                 <input
                                //                     type={que.answerType}
                                //                     className="form-control"
                                //                     name={que.id}
                                //                     id={que.id}
                                //                     value={additionalAnswers[que.id] ?? ''}
                                //                     onChange={handleQuestions}
                                //                 />
                                //             ) : (
                                //                 <div>
                                //                     <label>
                                //                         <input
                                //                             type="radio"
                                //                             className="radio"
                                //                             name={que.id}
                                //                             id={que.id}
                                //                             value={true}
                                //                             onChange={handleQuestions}
                                //                         />
                                //                         &nbsp;{advertisementDetailsLabel.YES}
                                //                         &nbsp;&nbsp;
                                //                     </label>
                                //                     <label>
                                //                         <input
                                //                             type="radio"
                                //                             className="radio"
                                //                             name={que.id}
                                //                             id={que.id}
                                //                             value={false}
                                //                             onChange={handleQuestions}
                                //                         />
                                //                         &nbsp;{advertisementDetailsLabel.NO}
                                //                     </label>
                                //                 </div>
                                //             )}
                                //         </td>
                                //     </tr>
                                // )
                            )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default QuestionDetails;
